import {
  SET_NAVEGATION_STEPS, LOADING_NAVEGATION_STEPS, SET_ERROR_NAVEGATION_STEPS, SET_CURRENT_NAVEGATION_STEPS, SET_CURRENT_STEP, SET_VALIDATE_FIELDS, SET_IS_VALID_FIELDS
} from './types'

const initialState = {
  navegations: {
    "PessoaFisica": {
      "Observacao": "",
      "Produtos": [
        {
          "Id": "f46289e3-7cb9-46e1-9c33-1452f5154c73",
          "Nome": "Transações de até 10 mil USD¹ em até 30 dias ou 20 mil USD¹ em até 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPF",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_cpf",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  
                  }
                },
                {
                  "chave": "dadosIniciais_nomeCompleto",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_tipoDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_orgaoEmissor",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataEmissao",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_paisDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataVencimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_numeroDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneCelular",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataNascimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_email",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 3,
              "URL": "/dadosComplementares",
              "Nome": "Dados Complementares",
              "Campos": [
                {
                  "chave": "dadosComplementares_genero",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_estadoCivil",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomeMae",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_PaisNascimento",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_SocialSecurityNumber",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            },  
            {
              "Id": 4,
              "URL": "/documentosAnexos",
              "Nome": "Documentos Anexados",
              "Campos": [
                {
                  "Id": 1,
                  "IdTipoDocumento": 15,
                  "chave": "documentos_documentoIdentificacaoFrente",
                  "obrigatorio": true
                },
                {
                  "Id": 2,
                  "IdTipoDocumento": 15,
                  "chave": "documentos_documentoIdentificacaoVerso",
                  "obrigatorio": false
                },
                {
                  "Id": 3,
                  "IdTipoDocumento": 8,
                  "chave": "documentos_procuracaoComprovante",
                  "obrigatorio": true
                },
                {
                  "chave": "documentos_documentosProcuradorFalg",
                  "obrigatorio": true
                },
              ]
            }
          ]
        },
        {
          "Id": "0872a15a-4aa4-449b-8bcd-73edeacc836f",
          "Nome": "Transações superiores a 10 mil USD¹ em 30 dias ou a 20 mil USD¹ em 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPF",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_cpf",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  

                  }
                },
                {
                  "chave": "dadosIniciais_nomeCompleto",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_tipoDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_orgaoEmissor",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataEmissao",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_paisDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataVencimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_numeroDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneCelular",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataNascimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_email",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 3,
              "Nome": "Dados Complementares",
              "Campos": [
                {
                  "chave": "dadosComplementares_genero",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_estadoCivil",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomeConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_cpfConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_dataNascimentoConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },

                {
                  "chave": "dadosComplementares_nomeMae",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomePai",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosComplementares_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_PaisNascimento",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_SocialSecurityNumber",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": true,
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 5,
              "URL": "/declaracoesEspecificas",
              "Nome": "Declarações especificas obrigatórias",
              "Campos": [
                {
                  "chave": "declaracoesEspecificasObrigatorias_ocupacaoPrincipal",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_totalRendaMensal",
                  "obrigatorio": false
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_totalPatrimonio",
                  "obrigatorio": false
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_ppe",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_relacaoPessoaPpe",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            },
            {
              "Id": 4,
              "URL": "/documentosAnexos",
              "Nome": "Documentos Anexados",
              "Campos": [
                {
                  "Id": 1,
                  "IdTipoDocumento": 15,
                  "chave": "documentos_documentoIdentificacaoFrente",
                  "obrigatorio": true
                },
                {
                  "Id": 2,
                  "IdTipoDocumento": 15,
                  "chave": "documentos_documentoIdentificacaoVerso",
                  "obrigatorio": true
                },
                {
                  "Id": 3,
                  "IdTipoDocumento": 3,
                  "chave": "documentos_comprovanteResidenciaComprovante",
                  "obrigatorio": true
                },
                {
                  "Id": 4,
                  "IdTipoDocumento": 7,
                  "chave": "documentos_comprovanteRendaComprovante",
                  "obrigatorio": true
                },
                {
                  "Id": 3,
                  "IdTipoDocumento": 8,
                  "chave": "documentos_procuracaoComprovante",
                  "validacoes": {
                    "obrigatorio": true,
                    "visivel": [
                      {
                        "campo": "documentos_documentosProcuradorFalg",
                        "valor": true,
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "documentos_documentosProcuradorFalg",
                  "obrigatorio": true
                },
              ]
            }
          ]
        }
      ]
    },
    "PessoaJuridica": {
      "Observacao": "",
      "Produtos": [
        {
          "Id": "080584eb-d102-4663-8c67-1f3be4a700ca",
          "Nome": "(i) Câmbio Comercial",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPJ",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  
                  }
                },
                {
                  "chave": "dadosIniciais_razaoSocial",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_cnpj",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_nomeContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_emailContato",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 5,
              "URL": "/declaracoesEspecificas",
              "Nome": "Declarações especificas obrigatórias",
              "Campos": [

                {
                  "chave": "declaracoesEspecificasObrigatorias_socioPpe",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_participanteFatca",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_participanteGiin",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "declaracoesEspecificasObrigatorias_participanteFatca",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_nif",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "declaracoesEspecificasObrigatorias_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            }  
          ]
        },
        {
          "Id": "004da246-c24b-40da-ac37-aad340847479",
          "Nome": "(ii)  Câmbio Turismo – Transações de até 30 mil USD¹ em 30 dias ou 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPJ",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  
                  }
                },
                {
                  "chave": "dadosIniciais_razaoSocial",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_cnpj",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_nomeContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_emailContato",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            },
            {
              "Id": 4,
              "URL": "/documentosAnexos",
              "Nome": "Documentos Anexados",
              "Campos": [
                {
                  "Id": 3,
                  "IdTipoDocumento": 8,
                  "chave": "documentos_procuracaoComprovante",
                  "validacoes": {
                    "obrigatorio": true,
                    "visivel": [
                      {
                        "campo": "documentos_documentosProcuradorFalg",
                        "valor": true,
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "Id": 2,
                  "IdTipoDocumento": 9,
                  "chave": "documentos_contratoSocialComprovante",
                  "obrigatorio": true
                },
                {
                  "chave": "documentos_documentosProcuradorFalg",
                  "obrigatorio": true
                },
              ]
            }
          ]
        },
        {
          "Id": "360af01f-024e-4f55-a6ea-bb4b4977df92",
          "Nome": "(iii) Câmbio Turismo – Transações supeiores a 30 mil USD¹ em 30 dias ou 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPJ",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  
                  }
                },
                {
                  "chave": "dadosIniciais_razaoSocial",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_cnpj",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_nomeContato",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_emailContato",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 5,
              "URL": "/declaracoesEspecificas",
              "Nome": "Declarações especificas obrigatórias",
              "Campos": [

                {
                  "chave": "declaracoesEspecificasObrigatorias_socioPpe",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_participanteFatca",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_participanteGiin",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "declaracoesEspecificasObrigatorias_participanteFatca",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_nif",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "declaracoesEspecificasObrigatorias_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            }
          ]
        }
      ]
    },
    "PessoaEstrangeira": {
      "Observacao": "",
      "Produtos": [
        {
          "Id": "f46289e3-7cb9-46e1-9c33-1452f5154c73",
          "Nome": "Transações de até 10 mil USD¹ em até 30 dias ou 20 mil USD¹ em até 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "/dadosIniciaisPF",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  

                  }
                },
                {
                  "chave": "dadosIniciais_nomeCompleto",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_tipoDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_numeroDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneCelular",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataNascimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_email",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 3,
              "URL": "/dadosComplementares",
              "Nome": "Dados Complementares",
              "Campos": [
                {
                  "chave": "dadosComplementares_genero",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_estadoCivil",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomeMae",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_PaisNascimento",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_NumeroSeguroSocial",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            }  
          ]
        },
        {
          "Id": "0872a15a-4aa4-449b-8bcd-73edeacc836f",
          "Nome": "Transações superiores a 10 mil USD¹ em 30 dias ou a 20 mil USD¹ em 12 meses",
          "Grupos": [
            {
              "Id": 1,
              "URL": "dadosIniciaisPF",
              "Nome": "Dados Iniciais",
              "Campos": [
                {
                  "chave": "dadosIniciais_codigoGerente",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosIniciais_nomeGerente",
                  "obrigatorio": false,
                  "validacoes": {
                    "visivel": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ],
                    "obrigatorio": [
                      {
                        "campo": "dadosIniciais_codigoGerente",
                        "valor": null,
                        "teste": "<>"
                      }
                    ]  
                  }
                },
                {
                  "chave": "dadosIniciais_nomeCompleto",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_tipoDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_numeroDocumento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_telefoneCelular",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_dataNascimento",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosIniciais_email",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 2,
              "URL": "/endereco",
              "Nome": "Endereço",
              "Campos": [
                {
                  "chave": "endereco_pais",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cep",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_logradouro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_numero",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_complemento",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_bairro",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_cidade",
                  "obrigatorio": true
                },
                {
                  "chave": "endereco_telefoneFixo",
                  "obrigatorio": false
                },
                {
                  "chave": "endereco_estado",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 3,
              "URL": "",
              "Nome": "Dados Complementares",
              "Campos": [
                {
                  "chave": "dadosComplementares_genero",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_estadoCivil",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomeConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_cpfConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_dataNascimentoConjuge",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_estadoCivil",
                        "valor": "2",
                        "teste": "="
                      }
                    ]
                  }
                },

                {
                  "chave": "dadosComplementares_nomeMae",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_nomePai",
                  "obrigatorio": false
                },
                {
                  "chave": "dadosComplementares_pessoaAmericana",
                  "obrigatorio": true
                },
                {
                  "chave": "dadosComplementares_PaisNascimento",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                },
                {
                  "chave": "dadosComplementares_NumeroSeguroSocial",
                  "validacoes": {
                    "obrigatorio": [
                      {
                        "campo": "dadosComplementares_pessoaAmericana",
                        "valor": "true",
                        "teste": "="
                      }
                    ]
                  }
                }
              ]
            },
            {
              "Id": 5,
              "URL": "",
              "Nome": "Declarações especificas obrigatórias",
              "Campos": [
                {
                  "chave": "declaracoesEspecificasObrigatorias_ocupacaoPrincipal",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_totalRendaMensal",
                  "obrigatorio": false
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_totalPatrimonio",
                  "obrigatorio": false
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_totalPatrimonio",
                  "obrigatorio": false
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_ppe",
                  "obrigatorio": true
                },
                {
                  "chave": "declaracoesEspecificasObrigatorias_relacaoPessoaPpe",
                  "obrigatorio": true
                }
              ]
            },
            {
              "Id": 8,
              "URL": "/maisDetalhes",
              "Nome": "Mais Detalhes",
              "Campos": [
                {
                  "chave": "maisDetalhes_field",
                  "obrigatorio": false
                }
              ]
            }
          ]
        }
      ]
    }
  },
  currentNavegation: {},
  currentStep: null,
  loading: false,
  error: null,
  validateFields: false,
  isValidFields: false
}


export default function navegationStepsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_NAVEGATION_STEPS:
      return { ...state, navegations: action.payload }
    case SET_CURRENT_NAVEGATION_STEPS:
      return { ...state, currentNavegation: action.payload }
    case SET_CURRENT_STEP:
      return { ...state, currentStep: action.payload }
    case LOADING_NAVEGATION_STEPS:
      return { ...state, loading: action.payload }
    case SET_ERROR_NAVEGATION_STEPS:
      return { ...state, error: action.payload }
    case SET_VALIDATE_FIELDS:
      return { ...state, validateFields: action.payload }
    case SET_IS_VALID_FIELDS:
      return { ...state, isValidFields: action.payload }
    default:
      return state
  }
}

